import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth.config';

export default new PublicClientApplication(msalConfig);
